<style lang="scss" scoped>
.invalid-feedback {
  display: block;
}
</style>

<template>
  <div>
    <div
      :class="{ 'is-invalid': hasErrors, [colClass]: true }"
      class="custom-control custom-checkbox"
    >
      <input
        class="custom-control-input"
        type="checkbox"
        :name="attribute.name"
        :id="attribute.name"
        v-model="modelValue"
        @input="$emit('input', $event.target.checked)"
        @change="emitEvent($event.target.checked)"
        :disabled="isDisabled"
      />
      <label class="custom-control-label" :for="attribute.name"></label>
    </div>
    <div
      v-for="error in attribute.errors"
      :key="error"
      class="invalid-feedback"
    >
      {{ error }}
    </div>
  </div>
</template>

<script lang="babel">
export default {
  props: {
    value: {
      required: true,
    },
    attribute: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      modelValue: this.value,
      originalValue: this.value
    };
  },
  created() {
    this.emitEvent(this.value);
  },
  computed: {
    colClass() {
      const col = this.attribute.col !== undefined ? this.attribute.col : 12;
      return `col-${col}`;
    },
    hasErrors() {
      return this.attribute.errors.length !== 0;
    },
    isDisabled() {
      if(!this.attribute.cantDisable) {
        return false;
      }
      return this.originalValue;
    }
  },
  methods: {
    emitEvent(status) {
      let str = 'checkbox-'+ this.attribute.name.replace(new RegExp('_', 'g'), '-')+'-clicked';
      this.$bus.$emit(str, status);
    }
  }
}
</script>
